<div class="component-container flex flex-col h-full">
  <div class="details flex-1 overflow-y-auto">
    @if (!editChangeInWorkRequestForm) {
      <div class="heading text-type-2 mb-[40px]">
        Create request
      </div>
    }
    <app-text-input
      [ngClass]="{'!mt-[20px] !mb-[0px]':editChangeInWorkRequestForm}"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="requestNo"
      label="request No"
      />
    @if (changeOrderCreateMode === 'auto') {
      <app-text-input
        [ngClass]="{'!mt-[20px] !mb-[0px]':editChangeInWorkRequestForm}"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="orderNo"
        label="change Order No"
        />
    }
    <div [ngClass]="{ 'mt-[40px]': editChangeInWorkRequestForm }"
      class="count-section flex justify-center items-center gap-[15px] mb-[40px]">
      <div class="total-amount-change flex flex-col gap-[12px] w-1/2">
        <div class="label text-type-13 uppercase">
          Total Amount Change:
        </div>
        <div class="value text-type-8">
          ${{ totalAmount | number:'1.2-2' }}
        </div>
      </div>
      <div class="total-working-days flex flex-col gap-[12px] w-1/2">
        <app-text-input
          [parentFormGroup]="form"
          controlName="totalAdditionalDays"
          label="total Additional Working Days"
          type="number"
        />
      </div>
    </div>
    <div class="item-section flex flex-col gap-[20px] mb-[40px]">
      <div class="items-list flex flex-col gap-[40px]">
        <!-- Lines Accordion -->
        @if (lineKeys?.length) {
          @for (lineKey of lineKeys; track lineKey; let i = $index) {
            <div>
              <div [class.is-expanded]="selectedLineId === lineKey"
                [class.has-item]="!!form?.controls[lineKey]?.['controls']?.['itemNo']?.value || !!form?.controls[lineKey]?.['controls']?.['desc']?.value"
                [id]="lineKey"
                class="line-accordion border-[1px] border-[#C2C8DC] rounded-[4px] p-[16px]">
                <div class="line-header flex flex-col gap-[12px]">
                  <div class="line-accordion-heading text-type-13 uppercase flex justify-between items-center">
                    <div (click)="selectLine(lineKey)" class="heading-label cursor-pointer">
                      Item {{ i + 1 }}:
                    </div>
                    <div class="heading-action-section flex justify-center items-center gap-[20px]">
                      <mat-icon
                        (click)="selectLine(lineKey)"
                        [svgIcon]="selectedLineId === lineKey ? 'chevron-up' : 'chevron-down'"
                        class="accordion-icon chevron-icon cursor-pointer"
                        />
                      @if (editable) {
                        <mat-icon
                          (click)="deleteLine(lineKey)"
                          [svgIcon]="'trash'"
                          class="accordion-icon delete-icon cursor-pointer"
                          />
                      }
                    </div>
                  </div>
                  <div class="line-accordion-sub-heading flex justify-between items-center w-full">
                    <span #subHeadingSpan #subHeadingTooltip="matTooltip"
                      [matTooltip]="form?.controls[lineKey]?.['controls']?.['item']?.value"
                      [matTooltipDisabled]="true"
                      (mouseenter)="subHeadingTooltip.disabled = !isEllipsisActive(subHeadingSpan)"
                      matTooltipPosition="above"
                      matTooltipClass="project-name-tooltip"
                      class="truncate flex-1"
                      >
                      <span class="text-type-8">{{ form?.controls[lineKey]?.['controls']?.['itemNo']?.value }}</span><span class="text-type-10 ml-[6px] !normal-case">{{ form?.controls[lineKey]?.['controls']?.['desc']?.value | sentenceCase }}</span>
                    </span>
                    @if (lineSourceRequests[lineKey]) {
                      <span class="source-request-badge text-type-14"
                        matTooltip="Not on the bid sheet yet"
                        matTooltipPosition="above"
                        matTooltipClass="project-name-tooltip">
                        New item
                      </span>
                    }
                  </div>
                </div>
                <div class="line-content">
                  <app-change-in-work-request-line-item
                    [class.hidden]="selectedLineId !== lineKey"
                    [formGroup]="getLineGroup(lineKey)"
                    [lineKey]="lineKey"
                    [pendingBidItems]="pendingBidItems"
                    />
                </div>
              </div>
            </div>
          }
        }
      </div>
      @if (editable) {
        <div class="add-item text-type-9 cursor-pointer">
          <!-- Top-level line error -->
          @if (displayError) {
            <div #displayErrorRef class="error mb-[20px]">
              At least one line item or working days is required
            </div>
          }
          <span (click)="addItem()">Add item</span>
        </div>
      }
    </div>
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['overAllNotes']"
      [parentFormGroup]="form"
      class="w-full mb-[30px]"
      controlName="overAllNotes"
      label="Detailed Explanation of work requested"
      />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['fundingSource']"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="fundingSource"
      label="funding Source"
      />
    @if (form?.controls['delegatedLimit']?.value) {
      <app-view-field
        [value]="form?.controls['delegatedLimit']?.value"
        class="w-full mb-[30px]"
        label="delegated Limit"
        />
    }
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="false"
      [error]="errorMessages['subContractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="subContractor"
      label="Contractor"
      placeholder="Select"
      />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="false"
      [error]="errorMessages['changeInWorkCode']"
      [options]="changeInWorkCodeOptions"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="changeInWorkCode"
      label="change In Work Code"
      placeholder="Select"
      />
    @if (mediaFiles?.length) {
      <app-pictures-section
        (onDelete)="deletePicture($event)"
        [isEditable]="editable"
        [pictures]="mediaFiles"
        class="pictures-section mb-[40px] mt-[30px]"
        />
    }
  </div>

  <!-- Add + Save + Review Buttons -->
  @if ((!data?.id || data?.status === 'draft' || data?.status === 'rejected') && data?.status !== 'approved') {
    <div
      [ngClass]="{'mt-[40px]': !mediaFiles?.length}"
      class="action-section flex gap-[20px] pb-[10px] pl-[4px] w-full justify-center items-center flex-shrink-0"
      >
      <div [matMenuTriggerFor]="add" class="action-button add-button">
        <mat-icon class="add" svgIcon="plus"></mat-icon>
      </div>
      <app-secondary-button
        (handleClick)="save()"
        [isDisabled]="!isFormDirty"
        class="save-btn w-full flex-1"
        >
        Save
      </app-secondary-button>
      <app-primary-button
        (handleClick)="submit()"
        class="submit-btn w-full flex-1"
        >
        Review
      </app-primary-button>
    </div>
  } @else {
    <div
      [ngClass]="{'mt-[40px]': !mediaFiles?.length}"
      class="action-section flex gap-[20px] pb-[10px] pl-[4px] w-full justify-center items-center flex-shrink-0"
      >
      <app-primary-button
        (handleClick)="submit()"
        class="w-full flex-1 workflow-btn"
        >
        Review
      </app-primary-button>
    </div>
  }
</div>

<input
  #fileInput
  (change)="onFileSelected($event)"
  class="hidden"
  multiple="multiple"
  type="file" />
<mat-menu #add="matMenu">
  @for (option of addMenuOptions; track option) {
    <button
      (click)="option.handler()"
      mat-menu-item
      >
      <div class="add-menu-item flex justify-start items-center">
        <div class="flex justify-center items-center h-[48px]">
          <mat-icon [svgIcon]="option.icon" class="menu-icon" />
        </div>
        <div class="menu-label">{{ option.label }}</div>
      </div>
    </button>
  }
</mat-menu>
